import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { SignInComponent } from './sign-in.component';
import { IndexRoutingModule } from '@zwiloo/frontend/index/index-routing.module';
import { SharedModule } from '@zwiloo/frontend/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [SignInComponent],
  imports: [
    CommonModule,
    IndexRoutingModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    MatMenuModule,
  ],
})
export class SignInModule {}
